<label class="input-label">Selection values: </label>
<table class="table table-striped table-bordered align-middle bg-white"
       id="selections">
    <tbody cdkDropList 
            [cdkDropListData]="fieldOptions.values" 
            (cdkDropListDropped)="dropped($event)">
        <tr cdkDrag *ngFor="let selection of fieldOptions.values; let i = index">
            <td>
                <span><i class="fas fa-arrows-alt handle mr-2"></i></span><span>{{ selection.value }}</span>
            </td>
            <td *ngIf="!guideIsBoolean"
                 class="text-center fit-cell">
                <confirmation [showTrashIcon]="true"
                              [question]="'confirm.areyousure'"
                              (isConfirmed)="deleteSelection($event, i);">
                </confirmation>
            </td>
        </tr>
    </tbody>
    <tfoot *ngIf="!guideIsBoolean">
        <tr>
            <td>
                <input class="form-control"
                       type="text"
                       name="newSelection"
                       [(ngModel)]="newSelection">
            </td>
            <td class="text-center fit-cell">
                <button class="addBtn services-icon--add"
                        type="submit"
                        (click)="addSelection(newSelection); newSelection=''">{{ 'general.add' | translate }}
                </button>
            </td>
        </tr>
    </tfoot>
</table>